import {
  GroupVisitSessionControllerApi,
  GroupVisitSharedNote,
} from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  sessionId: string;
  groupVisitSharedNote: GroupVisitSharedNote;
};

export const useUpdateGroupNote = () =>
  useMutationWithLoading(async ({ sessionId, groupVisitSharedNote }: Params) =>
    new GroupVisitSessionControllerApi(getConfigObject()).updateGroupNote(
      sessionId,
      groupVisitSharedNote,
      getXtenantId()
    )
  );
